<template>
    <div class="acountStatus">
        <div class="mainTitle text-center mb-4">
            <h2 class="mb-3 mt-4"> {{ $t('withdrawList') }}</h2>
            <message-component :message="response_msg" :messageType="msg_type"
                v-if="response_msg != ''"></message-component>
        </div>
        <div class="whiteBG radius pt-3">
            <div class="d-flex flex-wrap tabcenter justify-content-between border-bottom pb-3 px-3 mb-2">
                <div class="accountType  d-flex justify-content-start align-items-center">
                    <a :class="(listStatus == '') ? 'active' : ''" href="#" @click.prevent="filter('')">
                        {{ $t('withdrawList_all') }}</a>
                    <a :class="(listStatus == '0') ? 'active' : ''" href="#" @click.prevent="filter('0')">
                        {{ $t('withdrawList_pending') }}</a>
                    <a :class="(listStatus == '1') ? 'active' : ''" href="#" @click.prevent="filter('1')">
                        {{ $t('withdrawList_processed') }}</a>
                    <a :class="(listStatus == '3') ? 'active' : ''" href="#" @click.prevent="filter('3')">
                        {{ $t('withdrawList_rejected') }}</a>
                </div>
                <div class="requestbtn d-flex align-items-center">
                    <filter-component ref="form"></filter-component>
                </div>
            </div>
            <div class="inMiddle-area table-responsive">
                <table class="table pmmTable">
                    <thead>
                        <tr>
                            <th> {{ $t('withdrawList_created') }}</th>
                            <th> {{ $t('withdrawList_accountId') }}</th>
                            <th> {{ $t('withdrawList_amount') }}</th>
                            <th> {{ $t('withdrawList_currency') }}</th>
                            <th> {{ $t('withdrawList_withdrawalType') }}</th>
                            <th> {{ $t('withdrawList_method') }} </th>
                            <th> {{ $t('withdrawList_withdrawalStatus') }}</th>
                            <th> {{ $t('withdrawList_detail') }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="(!pageLoader && withdrawalList != '' && withdrawalList.totalRecords > 0)">
                        <tr v-for="list in withdrawalList.records">
                            <td>{{ list.created | moment("DD MMMM YYYY") }}</td>
                            <td>
                                <p
                                    v-html="(list.wallet_no != '' && list.wallet_no != null && list.wallet_no != undefined) ? list.wallet_no : list.account_id">
                                </p>
                            </td>
                            <td>{{ list.amount }}</td>
                            <td><img :src="'../../../../static/fxView/images/' + $env_var.currency[list.currency.toUpperCase()]"
                                    class="data_currency rounded-circle"></td>
                            <td>{{ $env_var.withdrawalType[list.withdrawal_type] }}</td>
                            <td>{{(parseInt(list.withdrawal_method) == 28 || parseInt(list.withdrawal_method) == 29) ? 'Bank' : $env_var.depositMethod[list.withdrawal_method]}}</td>
                            <td><span class="badge badge-pill"
                                    :class="(parseInt(list.withdrawal_status) == 2) ? 'badge-danger' : 'badge-warning'">{{ $env_var.withdrawalStatus[list.withdrawal_status] }}</span>
                            </td>
                            <td>
                                <router-link :to="{ name: 'fxView.view', query: { 'id': list.ticket_id } }"
                                    class="prism_btn width_xs btn_xs green_btn" title="View" data-placement="top"
                                    data-toggle="tooltip" @click.native="viewTicketEvent">
                                    {{ $t('withdrawList_viewTicket') }}
                                </router-link>
                                <a title="Cancel Withdrawal Request" v-if="(list.withdrawal_status == '0') && (list.IS_LOCKED == '0')" href="javascript:void(0)" class="close red" @click="cancelwithData = list">
                                    <feather type="x-circle"></feather>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span"
                        :list="withdrawalList" v-else-if="!pageLoader"></loader-component>
                </table>
            </div>
            <div class="border-top ">
                <pagination :getList="withdrawalList" :limit="pageLimit" v-if="withdrawalList.totalRecords > 15">
                </pagination>
            </div>
        </div>

        <div class="modal fade show" style="display: block;" v-if="Object.keys(cancelwithData).length > 0">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">{{$t('fxCancelWithdrawalRequest')}}</h5>
                        <button type="button" class="close" @click="cancelwithData = {}">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body my-3">
                        <h4>{{ $t('fxAreYouSureWithdrawal') }}</h4>
                        <p>{{list}}</p>
                    </div>
                    <div class="modal-footer">
                        <a href="javascript:void(0)" class="common_btn redBG" @click="cancelwithData = {}">{{$t('fxCancel')}}</a>
                        <a href="javascript:void(0)" class="common_btn " @click="cancelwithdrawalreq(cancelwithData.ticket, cancelwithData.ticket_id)">{{$t('fxProceed')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { fxViewMixins } from '@/plugins/fxView'
import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
export default {
    name: 'Dashboard',
    mixins: [fxViewMixins],
    data() {
        return {
            //===========prop in loader component=======
            col_span: 7,
            //============message and loader ===========
            response_msg: '',
            msg_type: '',
            pageLoader: false,
            loaderFuncRun: '1',
            listStatus: '',
            //==========================================
            pageLimit: '15',
            search: '',
            page: '1',
            pagename: 'withdrawal-list',
            cancelwithData:{}
        }
    },
    methods: {
        //cancel withdrawal request
        cancelwithdrawalreq(ticket, ticket_id) {
            if(this.pageLoader) {
                return
            }
            let input_json = {
                'globalParams': {
                    'ticket': ticket,
                    'ticket_id': ticket_id
                },
                'localParams': { "parameter": this }
            }
            this._runCancelWithdrawalRequest(input_json)
        },
        filter(getData) {
            this.listStatus = getData
            this.$refs.form.resetdata()
        },
        listing() {
            if (this.search != '') {
                this.loaderFuncRun = '0'
            }
            let inputJson = {
                'globalParams': {
                    filter: { 'withdrawal.withdrawal_status': this.listStatus },
                    sort: [],
                    search: this.search,
                    page: this.page,
                    perPage: parseInt(this.pageLimit),
                },
                'localParams': { 'parameter': this, 'loaderFuncRun': this.loaderFuncRun }
            }
            this._runGetWithdrawalList(inputJson)
        },
        viewTicketEvent(){
            this.$trackEvent('CP+Account+Funding+View+Ticket');
        }
    },
    created() {
        if (this.$store.getters[Const.GET_WITHDRAWAL_LIST] != '') {
            this.loaderFuncRun = '0'
        }
        this.listing()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/fxView/withdrawal/withdrawal_listing.vue